var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellGreen = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 4C10.4087 4 8.88261 4.63214 7.75739 5.75736C6.63217 6.88258 6.00003 8.4087 6.00003 10V13.586L5.29303 14.293C5.15322 14.4329 5.05802 14.611 5.01945 14.805C4.98088 14.9989 5.00068 15.2 5.07635 15.3827C5.15202 15.5654 5.28016 15.7215 5.44457 15.8314C5.60898 15.9413 5.80228 16 6.00003 16H18C18.1978 16 18.3911 15.9413 18.5555 15.8314C18.7199 15.7215 18.848 15.5654 18.9237 15.3827C18.9994 15.2 19.0192 14.9989 18.9806 14.805C18.942 14.611 18.8468 14.4329 18.707 14.293L18 13.586V10C18 8.4087 17.3679 6.88258 16.2427 5.75736C15.1175 4.63214 13.5913 4 12 4V4ZM12 20C11.2044 20 10.4413 19.6839 9.87871 19.1213C9.3161 18.5587 9.00003 17.7956 9.00003 17H15C15 17.7956 14.684 18.5587 14.1214 19.1213C13.5587 19.6839 12.7957 20 12 20Z",
  fill: "#11BC97"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell-green.5b20d75bcddb1801c6eb9d3e781fe7ae.svg";